import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import A1 from '../Images/logo-w.png';

const Emailverification = () => {
  const [email, setEmail] = useState('');
  const [otp, setOTP] = useState('');
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleOTPChange = (e) => {
    setOTP(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch('https://rvapi.emedha.in/auth/api/verify-otp', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email, otp }),
      });

      const data = await response.json();

      if (response.ok) {
        setVerified(true);
        setError('');
        alert('Email verified successfully! Product has been added to your cart.');
        navigate('/');
      } else {
        setError(data.error || 'Verification failed. Please try again.');
      }
    } catch (error) {
      console.error('Error verifying email:', error);
      setError('Verification failed. Please try again.');
    }
  };

  return (
    <div
      className="d-flex align-items-center justify-content-center min-vh-100"
      style={{
        background: 'linear-gradient(to right, #6a11cb 0%, #2575fc 100%)',
        padding: '20px',
      }}
    >
      <div
        className="p-4"
        style={{
          backgroundColor: 'white',
          borderRadius: '8px',
          boxShadow: '0 10px 20px rgba(0, 0, 0, 0.1)',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <div className="text-center">
          <img src={A1} alt="Logo" style={{ width: '150px', marginBottom: '15px' }} />
          <h2 className="mb-4" style={{ fontFamily: 'Arial, sans-serif', color: '#333' }}>
            Email Verification
          </h2>
        </div>

        {!verified ? (
          <Form onSubmit={handleSubmit}>
            {error && <Alert variant="danger">{error}</Alert>}
            <Form.Group className="mb-3" controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={handleEmailChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="otp">
              <Form.Label>OTP</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter OTP"
                value={otp}
                onChange={handleOTPChange}
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit" className="d-block w-100">
              Verify
            </Button>
          </Form>
        ) : (
          <Alert variant="success">Email verified!</Alert>
        )}

        <div className="text-center mt-3" style={{ fontSize: '14px' }}>
          <p>
            Don't have an account?{' '}
            <a href="/" className="text-decoration-none text-primary">
              Sign Up here
            </a>
          </p>
        </div>

        <div className="text-center mt-4" style={{ fontSize: '12px', color: '#777' }}>
          <p>&copy; 2025 E-medha technologies. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default Emailverification;
